module.exports = __webpack_public_path__ + "img/ltfw.e256946c.png";